export const DAY_REPORT_ID = 'day';
